<template>
  <div
    class="d-flex pa-2 flex-row flex-wrap"
    :style="{ height: 'fit-content' }"
  >
    <card-row :title="'Search'" :cardColor="'white'" :displayed="true">
      <div style="width: 100%">
        <v-row>
          <v-col cols="12" sm="6" md="3">
            <v-dialog
              ref="rangeDateDialog"
              v-model="rangeDateDialog"
              :return-value.sync="searchData.trx_datetime"
              persistent
              width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  id="rangeDate"
                  prepend-inner-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  v-model="dateRangeText"
                  label="Transaction Date"
                  hide-details="true"
                  dense
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="searchData.trx_datetime"
                scrollable
                range
                :min="minDate"
                :max="maxDate"
              >
                <v-spacer></v-spacer>
                <v-btn text color="accent" @click="rangeDateDialog = false">
                  Cancel
                </v-btn>
                <v-btn
                  text
                  color="accent"
                  @click="
                    () => {
                      checkRangeDate(searchData.trx_datetime);
                      $refs.rangeDateDialog.save(searchData.trx_datetime);
                    }
                  "
                >
                  OK
                </v-btn>
              </v-date-picker>
            </v-dialog>
          </v-col>
          <v-col cols="12" sm="6" md="3">
            <v-autocomplete
              id="merchants"
              ref="merchants"
              :search-input.sync="searchMerchant"
              v-model="searchData.mid"
              :items="merchantList"
              hide-selected
              label="MID"
              persistent-hint
              item-value="mid"
              item-text="mid"
              :loading="loadingMerchant"
              hint="Search by MID"
              clearable
              dense
            >
              <template v-slot:item="{ item }">
                {{ item.mid + ' - ' + item.merchant_name }}
              </template>
            </v-autocomplete>
          </v-col>
          <v-col cols="12" sm="6" md="3">
            <v-select
              v-model="searchData.payment_type"
              :items="listPaymentType"
              label="Payment Type"
              item-text="text"
              item-value="value"
              clearable
              hide-details="true"
              dense
            ></v-select>
          </v-col>
          <v-col cols="12" sm="6" md="3">
            <v-text-field
              v-model="searchData.invoice_number"
              label="Invoice Number"
              type="text"
              hide-details="true"
              dense
            ></v-text-field>
          </v-col>

          <v-col cols="12" sm="6" md="6">
            <v-text-field
              v-model="searchData.rrn"
              label="Reff ID"
              type="text"
              hide-details="true"
              dense
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="3">
            <v-text-field
              v-model="searchData.trx_pan"
              label="Transaction PAN"
              type="text"
              hide-details="true"
              dense
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="3">
            <v-select
              v-model="searchData.status"
              :items="listTrxReportStatus"
              label="Status Transaksi"
              item-text="text"
              item-value="value"
              clearable
              hide-details="true"
              dense
            ></v-select>
          </v-col>
        </v-row>
        <v-row class="d-flex align-center justify-left">
          <v-col cols="12">
            <v-btn @click="clearSearch"> Reset </v-btn>
            <v-btn
              color="primary"
              class="ml-2"
              @click.stop="getData"
              :loading="loading"
              >show</v-btn
            >
          </v-col>
        </v-row>
      </div>
    </card-row>
  </div>
</template>

<script>
import {
  dataListPaymentType,
  dataListTrxReportCptsStatus,
  dataMinRangeDate,
  dataMaxRangeDate,
} from '../../store/params';
import { getDate, date } from '../../lib/helpers';

export default {
  components: { CardRow: () => import('../CardRow.vue') },
  props: ['search', 'loading'],
  data: () => ({
    today: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
      .toISOString()
      .slice(0, 10),
    loadingMerchant: false,
    listPaymentType: dataListPaymentType,
    listTrxReportStatus: dataListTrxReportCptsStatus,
    rangeDateDialog: false,
    searchMerchant: '',
    acId: null,
    mId: null,
  }),
  watch: {
    searchMerchant(val) {
      if (val && val.length >= 3) {
        this.mId = val;
        this.getMerchant();
      } else {
        this.mId = '';
        this.$store.commit('report/clearMerchant');
      }
    },
  },
  computed: {
    searchData: {
      get() {
        return this.search;
      },
      set(newValue) {
        this.$emit('update:search', newValue);
      },
    },
    dateRangeText() {
      return this.searchData.trx_datetime.join(' ~ ');
    },
    merchantList() {
      return this.$store.state.report.merchantList;
    },
    minDate() {
      if (this.searchData.trx_datetime.length > 0) {
        const tempMinDate = Date.parse(this.searchData.trx_datetime[0]);
        return this.getDate(dataMinRangeDate, tempMinDate);
      }
      return '';
    },
    maxDate() {
      if (this.searchData.trx_datetime.length > 0) {
        const tempMaxDate = Date.parse(this.searchData.trx_datetime[0]);
        const maxDate = this.getDate(dataMaxRangeDate, tempMaxDate);
        return maxDate > this.today ? this.today : maxDate;
      }
      return this.today;
    },
  },
  methods: {
    getMerchant() {
      this.loadingMerchant = true;
      this.$store.commit('report/setFlashErrorMessage', '');
      this.$store
        .dispatch('report/getMerchant', {
          date,
          sortBy: 'ID',
          search: { mid: this.mId, qr_type: 8 },
          source: 'merchant',
        })
        .then(() => {
          this.loadingMerchant = false;
        });
    },

    checkRangeDate(trx_datetime) {
      trx_datetime.sort();
      if (trx_datetime.length == 1) {
        trx_datetime.push(this.searchData.trx_datetime[0]);
      }
    },

    clearSearch() {
      this.$emit('clearSearchParent');
    },
    getData() {
      this.$emit('getDataParent');
    },
    getDate,
  },
};
</script>
